import React, { Component } from "react";
import { Row, Col } from "react-bootstrap";
import LoggedOutFrame from "../../lib/logged_out_frame";
import AdminSignInAsForm from "./admin_sign_in_as_form";
import { parse } from "query-string";
import UserStore from "../../../lib/user_store";

class AdminSignInAsPage extends Component {
  componentDidMount() {
    const { email } = parse(window.location.search);

    const adminToken = UserStore.getAdminToken();
    if (adminToken && email) {
      this.loginAs({ adminToken, loginAsEmail: email });
    }
  }

  loginAs = (...args) => {
    this.props.loginAs(...args).then(resp => {
      if (resp.status === 200) {
        this.props.history.push("/shows");
      }
    });
  };

  render() {
    return (
      <LoggedOutFrame Title="Admin Sign In As..." subTitle="Sign in as another user">
        <Row>
          <Col xs={12} md={6} mdOffset={3}>
            <AdminSignInAsForm
              isLoading={this.props.isLoading}
              onSubmit={this.loginAs}
              user={this.props.user}
              logout={this.props.logout}
            />
          </Col>
        </Row>
      </LoggedOutFrame>
    );
  }
}

export default AdminSignInAsPage;
